import {
  ServicePanelTransitionConsumerService,
  ServicePanelType,
  TokensService,
  UsersService
} from '@/backend/auth'
import type { TokenEntity } from '../../domain/entities/TokenEntity'
import { AuthenticationRepository } from '../../domain/repositories/AuthenticationRepository'
import { AuthenticationModel } from '../models/AuthenticationModel'
import { TokenModel } from '../models/TokenModel'

export class AuthenticationRepositoryImpl implements AuthenticationRepository {
  async getAuthentication(): Promise<AuthenticationModel | 'error'> {
    try {
      const userModel = new AuthenticationModel({})

      return userModel
    } catch {
      return 'error'
    }
  }
  async getUserTokens(key: string): Promise<TokenEntity | { error: true }> {
    try {
      if (localStorage.getItem('accessToken')) {
        return {
          accessToken: localStorage.getItem('accessToken'),
          refreshToken: localStorage.getItem('refreshToken')
        }
      }
      const response =
        await ServicePanelTransitionConsumerService.postServicePanelTransitionConsumeAdmin({
          requestBody: {
            servicePanelType: ServicePanelType.MARKET,
            key
          }
        })
      const tokenModel = new TokenModel(response)
      return tokenModel
    } catch {
      return { error: true }
    }
  }
  async renewToken(): Promise<TokenEntity | { error: true }> {
    try {
      const response = await TokensService.postAccessTokenRenewAdmin({
        requestBody: {
          accessToken: localStorage.getItem('accessToken') ?? '',
          refreshToken: localStorage.getItem('refreshToken') ?? ''
        }
      })
      const tokenModel = new TokenModel(response)
      return tokenModel
    } catch {
      return { error: true }
    }
  }
  async logout(): Promise<{ success: true } | { error: true }> {
    try {
      await UsersService.postLogoutAdmin({
        requestBody: {
          refreshToken: localStorage.getItem('refreshToken') ?? ''
        }
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
}
